import { proxy } from 'valtio';
import { BrowserState, MicrophoneAccessType } from './types';

export const browserState = proxy<BrowserState>({
  microphoneAccess: MicrophoneAccessType.UNKNOWN,
  tries: 0,
  showMicrophoneAccessModal: false,
  isOnline: navigator.onLine,
});
